import { render } from "./ConfirmationModal.vue?vue&type=template&id=c24caa04&scoped=true"
import script from "./ConfirmationModal.vue?vue&type=script&lang=js"
export * from "./ConfirmationModal.vue?vue&type=script&lang=js"

import "./ConfirmationModal.vue?vue&type=style&index=0&id=c24caa04&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src2158973318/src/pricing_engine_frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c24caa04"]])

export default __exports__